import { ChevronLeft } from "lucide-react";
import Link from "next/link";
import React from "react";

interface PageHeaderProps {
  title: string;
  href?: string;
  navigator?: boolean;
}
const PageHeader = ({ title, href, navigator }: PageHeaderProps) => {
  return (
    <header className="flex py-4 px-5 w-full justify-center">
      {navigator && href && (
        <Link href={href} className="rounded-full p-2 bg-zinc-100/70">
          <ChevronLeft size={24} className="h-5 w-5" />
        </Link>
      )}
      <div className="flex w-full text-center justify-center">
        <p className="text-2xl">{title}</p>
      </div>
    </header>
  );
};

export default PageHeader;
